var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 15,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 3.121,
  width: 18,
  height: 3,
  rx: 1.5,
  transform: "rotate(45 3.121 0)",
  fill: "#212121"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.575,
  y: 12.805,
  width: 18,
  height: 3,
  rx: 1.5,
  transform: "rotate(-45 .575 12.805)",
  fill: "#212121"
})));
export default SvgClose;